import iframe from '@ps/bridge/iframe/iframe'
import { GlobalConfigBgClass } from '@ps/bridge/qc/base'
import store from '@ps/store'
import { getAbsoluteUrl } from '@ps/workbench/undo-redo/module/play-component'
import _ from 'lodash'

// 背景音乐预加载
export async function loadPsBgm() {
  return new Promise((resolve, reject) => {
    let bgmAudioUrl = getPsBgmUrl()
    if (_.isEmpty(bgmAudioUrl)) {
      resolve()
    } else {
      bgmAudioUrl = getAbsoluteUrl(bgmAudioUrl)
      const timestamp = store.state.workspace.game.bgm.timestamp
      const t =
        bgmAudioUrl.indexOf('?') > -1 ? `&ts=${timestamp}` : `?ts=${timestamp}`
      bgmAudioUrl += t
      const audioTag = getBgmAudioTag()
      if (audioTag) {
        audioTag.addEventListener('loadeddata', () => {
          resolve()
        })
        audioTag.loop = true
        audioTag.preload = 'auto'
        audioTag.src = bgmAudioUrl
        audioTag.style.display = 'none'
      }
    }
  })
}
function getBgmAudioTag() {
  let audioTag = document.getElementById('ps-bgm') as HTMLAudioElement
  if (!audioTag) {
    audioTag = document.createElement('audio') as HTMLAudioElement
    audioTag.id = 'ps-bgm'
    document.body.appendChild(audioTag)
  }
  return audioTag
}
function getPsBgmUrl() {
  const gamePlay = iframe.gamePlay
  const globalScript = gamePlay.getScript(GlobalConfigBgClass)
  const bgmAudioUrl = globalScript.bgmAudioUrl
  return bgmAudioUrl
}
export function playPsBgm() {
  const bgmAudioUrl = getPsBgmUrl()
  if (!_.isEmpty(bgmAudioUrl)) {
    const audioTag = getBgmAudioTag()
    audioTag.play()
  }
}

export function pausePsBgm() {
  const bgmAudioUrl = getPsBgmUrl()
  if (!_.isEmpty(bgmAudioUrl)) {
    const audioTag = getBgmAudioTag()
    audioTag.pause()
  }
}
